import type { SVGProps } from 'react'

const SvgFarm = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' {...props}>
    <path d='M2 21c-.283 0-.52-.096-.712-.287S1 20.283 1 20v-7.975a1.947 1.947 0 0 1 .85-1.625l5-3.575A1.896 1.896 0 0 1 8 6.45a1.884 1.884 0 0 1 1.15.375l5 3.575a1.94 1.94 0 0 1 .85 1.625V20c0 .283-.096.52-.287.713S14.283 21 14 21h-3c-.283 0-.52-.096-.712-.287S10 20.283 10 20v-4c0-.283-.096-.52-.287-.712S9.283 15 9 15H7c-.283 0-.52.096-.712.288S6 15.717 6 16v4c0 .283-.096.52-.287.713S5.283 21 5 21zm19 0h-3c-.283 0-.52-.096-.712-.287S17 20.283 17 20v-8.975c0-.333-.07-.642-.212-.925a1.833 1.833 0 0 0-.613-.7L10 4.95c0-.533.192-.992.575-1.375S11.417 3 11.95 3H21c.55 0 1.02.196 1.413.588S23 4.45 23 5v14c0 .55-.196 1.02-.587 1.413S21.55 21 21 21' />
  </svg>
)

export default SvgFarm
